import React from "react";
import EmptyPage from "../../components/EmptyPage";

const Shared = () => {
  return (
    <EmptyPage
      title="Shared Files"
      description="Collaborate with team members by sharing documents, reports, and files related to your real estate projects and deals."
      icon="📁"
    />
  );
};

export default Shared;
